// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"363e8124","150":"47c9b99f","193":"be8f6a32","455":"dc737e83","496":"971e0a3f","506":"71361269","534":"471dbcf1","536":"4f77e99e","557":"6353480e","811":"3b39a994","878":"a555ee51","885":"a7708f90","958":"6ba9139d","977":"c645d0bf"}[chunkId] + ".chunk.js";
};